module.exports = __webpack_public_path__ + "img/Homepage-Hero-Left-side.dbaaee6.svg";